import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '../style/publicCss.css'
import vue3SeamlessScroll from "vue3-scroll-seamless";

const app = createApp(App)
app.use(store).use(router).use(ElementPlus).use(vue3SeamlessScroll).mount('#app')

// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//     app.component(key, component)
// }

Object.keys(ElementPlusIconsVue).forEach((key) => {
    app.component(key, ElementPlusIconsVue[key]);
})

// 滚动插件 vue-seamless-scroll